module.exports = __webpack_public_path__ + "cement/img/蒙版组 120.fcbb18ef.png";